import { FC } from "react"
import { useTranslation } from "react-i18next"

import ColorModel from "models/Color"
import { Flex } from "components/Flex"
import ColorPreview from "./ColorPreview"
import FlexibleContent from "components/FlexibleContent/FlexibleContent"

interface IColorProps {
    color?: ColorModel | null
    unknown?: boolean
    condensed?: boolean
    reversed?: boolean
    highlight?: string
    clampedTooltip?: boolean
}

const Color: FC<IColorProps> = ({
    color,
    unknown,
    condensed,
    reversed,
    highlight,
    clampedTooltip = true,
}) => {
    const { t } = useTranslation()

    return (
        <Flex alignItems="center" flow={reversed ? "row-reverse" : "row"} gap={condensed ? "0.8rem" : "1.6rem"}>
            <ColorPreview code={unknown ? null : color?.code} unknown={unknown} />
            <FlexibleContent
                text={unknown ? t("colors.noPreference") : (color ? color.name : t("colors.noSpecialPaintDefault"))}
                clampedTooltip={clampedTooltip}
                highlight={highlight} />
        </Flex>
    )
}

export default Color
